

export const adminData = (data) => [
  {
    id: 1,
    title: "Completed Trip",
    ridenumber: data?.body[0]?.totalfinishedrides || 0,
    ridestatus: data?.body[0]?.totalFinishedRidesPercentage || '',
    color: "green",
  },
  {
    id: 2,
    title: "OnGoing Trip",
    ridenumber: data?.body[0]?.activeRides || 0,
    ridestatus: data?.body[0]?.activeRidesPercentage || '',
    // select: {
    //     option1:"Rental",
    //     option2:"Schedule",
    // },
    color: "green",
  },
  {
    id: 3,
    title: "Booked Trip",
    ridenumber: data?.body[0]?.upcomingRides || 0,
    ridestatus: data?.body[0]?.upcomingRidesPercentage || '',
    color: "green",
  },
  {
    id: 4,
    title: "Cancelled Trip",
    ridenumber: data?.body[0]?.canceledRides || 0,
    ridestatus: data?.body[0]?.canceledRidesPercentage || '',
    // select: {
    //     option1:"Driver",
    //     option2:"Customer",
    // },
    color: "red",
  },
  // {
  //   id: 5,
  //   title: 'Total Drivers',
  //   ridenumber: data?.body[0]?.totalDriver || 0
  // },
  // {
  //   id: 6,
  //   title: 'Active Drivers',
  //   ridenumber: data?.body[0]?.activeDriver || 0
  // },
  {
    id: 5,
    title: 'Drivers (Active/Total)',
    ridenumber: `${data?.body[0]?.activeDriver || 0}/${data?.body[0]?.totalDriver || 0}`
  },
  {
    id: 6,
    title: 'Driver Status (OnDuty/Active)',
    ridenumber: `${data?.body[0]?.onDutyDriver || 0}/${data?.body[0]?.activeDriver || 0}`
  },
  {
    id: 7,
    title: 'Active Sub-Vendors',
    ridenumber: data?.body[0]?.totalSubVendors || 0
  },
  {
    id: 8,
    title: 'Total Revenue',
    ridenumber: (data?.body[0]?.earning ? ('₹ ' + data?.body[0]?.earning) : '0')
  },
]


export const secondaryAdminData = (data) => [
  // {
  //   id: 0,
  //   title: 'Total Drivers',
  //   total: data?.body[0]?.totalDriver || 0
  // },
  // {
  //   id: 1,
  //   title: 'Active Drivers',
  //   total: data?.body[0]?.activeDriver || 0
  // },
  {
    id: 0,
    title: 'Drivers (Active/Total)',
    total: `${data?.body[0]?.activeDriver || 0}/${data?.body[0]?.totalDriver || 0}`
  },
  {
    id: 1,
    title: 'Driver Status (OnDuty/Active)',
    total: `${data?.body[0]?.onDutyDriver || 0}/${data?.body[0]?.activeDriver || 0}`
  },
  {
    id: 2,
    title: 'Active Sub-Vendors',
    total: data?.body[0]?.subvendor || 0
  },
  {
    id: 3,
    title: 'Total Revenue',
    total: (data?.body[0]?.earning ? ('₹ ' + data?.body[0]?.earning) : '0')
  },
  // {
  //     id:4,
  //     title: 'Total Pending Tickets',
  //     total: data?.body[0]?.totalPendingTickets
  // }
]

export const rideTrackDashboardData =
{
  header: [
    {
      label: 'ID',
      key: 'id',
    },
    {
      label: 'Customer',
      key: 'customer',
    },
    {
      label: 'Driver',
      key: 'driverName',
    },
    {
      label: 'Ride Type',
      key: 'rideType',
    },
    {
      label: 'Pick up',
      key: 'pickup',
    },
    {
      label: 'Drop',
      key: 'dropping',
    },
    {
      label: 'Amount',
      key: 'amount',
    },
  ],
  body: [
    {
      id: '3899499',
      customer: 'Danu .RY',
      rideType: 'One way Ride',
      driverName: 'John',
      pickup: 'Gopalan mall Bannerghatta Road ',
      dropping: 'Gopalan mall Bannerghatta Road ',
      amount: '₹1,89,774',
      status: 'Completed',
    },
  ],
}


export const vendorDashboardData = (data) => [
  {
    id: 1,
    title: "Active Sub-Vendors",
    ridenumber: data?.body[0]?.subvendor || 0,
  },

  {
    id: 2,
    title: "Total Drivers",
    ridenumber: data?.body[0]?.drivers || 0,
  },

  {
    id: 3,
    title: "OnGoing Trip",
    ridenumber: data?.body[0]?.activeRides || 0,
  },

  {
    id: 4,
    title: "Cancelled Trip",
    ridenumber: data?.body[0]?.canceledRides || 0,
  }

]

export const vendorDashboardSecondData = (data) => [
  {
    id: 2,
    title: "Tickets",
    ridenumber: data?.body[0]?.tickets || 0,
  },

  {
    id: 1,
    title: "Earning",
    ridenumber: data?.body[0]?.earning || 0,
  },
  {
    id: 1,
    title: 'Active Drivers',
    total: data?.body[0]?.activeDriver || 0
  },
  
  {
    id: 2,
    title: 'Total Revenue',
    total: (data?.body[0]?.earning ? ('₹ ' + data?.body[0]?.earning) : '0')
  },

  // {
  //     id:3,
  //     title:"SOS Count",
  //     ridenumber: data?.body[0]?.soscount || 0,
  //     rental: "Received",
  //     sos:data?.body[0]?.activesos || 0,
  //     status:'Active'
  // },

]

export const subVendorDashboardData = (data) => [
  {
    id: 2,
    title: "Total Drivers",
    ridenumber: data?.body[0]?.drivers || 0,
  },

  {
    id: 3,
    title: "OnGoing Trip",
    ridenumber: data?.body[0]?.activeRides || 0,
  },

  {
    id: 4,
    title: "Cancelled Trip",
    ridenumber: data?.body[0]?.canceledRides || 0,
  },

  {
    id: 1,
    title: "Tickets",
    ridenumber: data?.body[0]?.tickets || 0,
  },

]



export const subVendorDashboardSecondData = (data) => [

  //   {
  //     id:1,
  //     title:"Earning",
  //     ridenumber: data?.body[0]?.earning || 0,
  // },
  {
    id: 1,
    title: 'Active Drivers',
    total: data?.body[0]?.activeDriver || 0
  },
  {
    id: 2,
    title: 'Driver Status (OnDuty/Active)',
    total: `${data?.body[0]?.onDutyDriver || 0}/${data?.body[0]?.activeDriver || 0}`
  },
  {
    id: 3,
    title: 'Total Revenue',
    total: (data?.body[0]?.earning ? ('₹ ' + data?.body[0]?.earning) : '0')
  }

  // {
  //     id:3,
  //     title:"SOS Count",
  //     ridenumber: data?.body[0]?.soscount || 0,
  //     rental: "Received",
  //     sos: data?.body[0]?.activesos || 0,
  //     status:'Active'
  // },

]
export const filterdata = [

  {
    id: 1,
    primaryText: 'Location',
    subItems: [
      { value: 'Bangalore', key: 'Location' },
      { value: 'Chennai', key: 'Location' },
      { value: 'Mysore', key: 'Location' },
      { value: 'Kannur', key: 'Location' }
    ]
  }
];